import { BackButton } from '@/components';
import { SetupHdmi } from '@/features/SetupHdmi/SetupHdmi';
import { useDocumentTitle } from '@/hooks';

export default function SetupHdmiPage() {
    useDocumentTitle('setupHdmi');

    return (
        <div className="h-full relative overflow-y-auto @container">
            <BackButton variant="floating" />
            <SetupHdmi />
        </div>
    );
}
